
const removeCookie = function (name) {
    if (getCookie(name))
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT";
}

const setCookie = function (cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + "; " + expires;
}

const getCookie = function (cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
}

export default class AppStorage {

    static GetStorageKey(key) {
        if (typeof (Storage) !== "undefined") return localStorage.getItem(key);
        else return getCookie(key);

    }

    static SetStorageKey(key, value) {
        if (typeof (Storage) !== "undefined") localStorage.setItem(key, value);
        else setCookie(key, value);
    }

    static ClearStorageKey(key) {
        if (typeof (Storage) !== "undefined") localStorage.removeItem(key);
        else removeCookie(key);
    }

    static SetUserCredentials(session, token) {
        AppStorage.SetStorageKey("token", token);
        AppStorage.SetStorageKey("session", session);
        global.session = session;
        global.token = token;
    }

    static ClearUserCredentials() {
        AppStorage.ClearStorageKey("token");
        AppStorage.ClearStorageKey("session");
        global.session = null;
        global.token = null;
        global.permissions= null;
    }
    static RestoreSession() {
        global.session = AppStorage.GetStorageKey("session");
        global.token = AppStorage.GetStorageKey("token");
    }
}